import { isNativeAudioNode } from '../guards/native-audio-node';
export const createConnectMultipleOutputs = createIndexSizeError => {
  return function (outputAudioNodes, destination) {
    let output = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    let input = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    const outputAudioNode = outputAudioNodes[output];
    if (outputAudioNode === undefined) {
      throw createIndexSizeError();
    }
    if (isNativeAudioNode(destination)) {
      return outputAudioNode.connect(destination, 0, input);
    }
    return outputAudioNode.connect(destination, 0);
  };
};